import React from 'react';

import styled from '@emotion/styled';
import { mq, green01, text, baseDurationTime } from '../../_style';
import { Link } from 'gatsby';

export default class FilterBtn extends React.Component {
  constructor(props) {
    super(props);
    this.checked;
  }
  componentDidUpdate() {
    this.checked = this.props.query === this.props.value;
  }
  render() {
    const Container = styled.div`
      display: inline-flex;
      position: relative;
      overflow: hidden;
      border-radius: 2px;
      box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.09);
      background-color: #fff;
    `
    const tag = this.props.isRadio ? styled.label : styled.a;
    const Inner = tag`
      display: flex;
      flex-direction: column;
      width: 100%;
      padding-top: ${this.props.icon ? 22 : 20}px;
      padding-bottom: ${this.props.icon ? 15 : 19}px;
      ${mq.ie} {
        transform: translateY(2px);
      }
      padding-left: 6px;
      padding-right: 6px;
      text-align: center;
      font-size: 0;
      line-height: 1;
      cursor: pointer;
      text-align: center;
      ${mq.sp} {
        height: ${this.props.icon ? `110px` : `80px`};
        padding-top: ${this.props.icon ? 13 : 25}px;
        padding-bottom: ${this.props.icon ? 8 : 25}px;
        padding-left: 5px;
        padding-right: 5px;
      }
      span {
        display: flex;
        align-items: center;
        justify-content: center;
        flex: 1 0 auto;
        transition: color ${baseDurationTime} ease;
        ${this.checked && `color: ${green01};`}
        ${text('14px', 22 / 14)}
        font-feature-settings: "palt";
        ${mq.sp} {
          ${text('12px', 18 / 12)}
        }
      }
      &:hover {
        span {
          color: ${green01};
        }
      }
      ${this.props.icon &&
        `
        &::before, &::after {
          content: "";
          display: block;
          width: 65px;
          height: 65px;
          margin: 0 auto 15px;
          background-size: contain;
          background-position: center;
          ${mq.sp} {
            width: 50px;
            height: 50px;
            margin: 0 auto 6px;
          }
        }
        &::before {
          background-image: url(${this.props.icon});
        }
        &::after {
          position: absolute;
          top: 22px;
          left: 0;
          right: 0;
          background-image: url(${this.props.iconActive});
          transition: opacity ${baseDurationTime} ease;
          opacity: ${this.checked ? '1' : '0'};
          ${mq.sp} {
            top: 13px;
          }
        }
        &:hover {
          ::after {
            opacity: 1;
          }
        }
      `}
    `;
    const Input = styled.input`
      appearance: none;
      &[type="radio"] {
        display: none;
      }
    `;
    const ButtonLink = !this.props.isRadio && Inner.withComponent(Link);
    const TagName = !this.props.isRadio ? ButtonLink : Inner;
    return (
      <Container>
        <TagName
          icon={this.props.icon}
          to={this.props.to ? this.props.to : null}
        >
          <span>{this.props.children}</span>
          {this.props.isRadio && (
            <Input
              type="radio"
              name={this.props.name}
              value={this.props.value}
              data-categoryname={this.props.categoryName}
              checked={this.props.query === this.props.value}
              onChange={this.props.fun}
            />
          )}
        </TagName>
      </Container>
    );
  }
}
